/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TimegridScheduleNote/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Action from './Action/index'
import AlertCheckbox from './AlertCheckbox/index'
import BlockTimeCheckbox from './BlockTimeCheckbox/index'
import CancelAction from './CancelAction/index'
import Chairs from './Chairs/index'
import Description from './Description/index'
import Header from './Header/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Interval from './Interval/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TimegridScheduleNote({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<div
  data-testid="TimegridScheduleNote.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1aOJo6': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-2-Z1aOJo6': dtColorsWhite,'--pt-3-Z1aOJo6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-Z1aOJo6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-5-Z1aOJo6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-6-Z1aOJo6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<Header
  viewPath={`${viewPath}/Header`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
<Chairs
  viewPath={`${viewPath}/Chairs`}
/>
<Interval
  viewPath={`${viewPath}/Interval`}
/>
<AlertCheckbox
  viewPath={`${viewPath}/AlertCheckbox`}
/>
<BlockTimeCheckbox
  viewPath={`${viewPath}/BlockTimeCheckbox`}
/>
<div
  data-testid="TimegridScheduleNote.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1aOJo6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-Z1aOJo6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<Action
  viewPath={`${viewPath}/Action`}
/>
</div>
</div>
{children}
</React.Fragment>)
}